<mat-toolbar color="primary" class="top-bar" *ngIf="!(embeddedMode$ | async)">
  <mat-toolbar-row>
    <div
      class="top-bar-home-icon"
      [routerLink]="'workspaces'"
      (click)="onSelectedWorkspaceRemove()"
      onclick="this.blur()"
    >
      <img src="assets/icons/wtr-icons/24x24/home.svg" class="home-icon" alt="thin client" />
    </div>
    <div class="top-bar-home-separator"></div>

    <img src="assets/images/cloud-twin-logo.svg" class="tc-logo" alt="thin client" />

    <a class="app-title" [routerLink]="''" [title]="titleKey | translate"
      >{{ titleKey | translate }}
    </a>

    <ng-content select="[after-title]"> </ng-content>

    <div class="top-bar-button">
      <ng-content select="[before-buttons]"> </ng-content>

      <span [hidden]="!rightPanelVisibility">
        <button
          mat-icon-button
          [disabled]="disabledRightPanelButtons"
          color="secondary"
          [matTooltip]="T_SCOPE + '.change-details-visibility' | translate"
          (click)="toggleVisibility()"
        >
          <mat-icon class="top-bar-icon" svgIcon="view-split-vertical-2"></mat-icon>
        </button>
      </span>

      <span [hidden]="rightPanelVisibility">
        <button
          mat-icon-button
          color="secondary"
          [disabled]="disabledRightPanelButtons"
          [matTooltip]="T_SCOPE + '.change-details-visibility' | translate"
          (click)="toggleVisibility()"
        >
          <mat-icon class="top-bar-icon" svgIcon="view-split-vertical"></mat-icon>
        </button>
      </span>

      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        color=""
        [matTooltip]="T_SCOPE + '.user-actions' | translate"
      >
        <mat-icon>account_circle</mat-icon>
      </button>

      <ng-content select="[after-buttons]"> </ng-content>
    </div>

    <div class="menuItems">
      <mat-menu #menu="matMenu" class="account-card-menu">
        <div class="mat-menu-content-x">
          <tc-main-account-card> </tc-main-account-card>
        </div>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
